import { Pill } from '@iwoca/orion';

type TProps = { isActive: boolean };

export const StatusCell = ({ isActive }: TProps) => {
  return (
    <Pill variant={isActive ? 'green' : 'london'} size="small">
      {isActive ? 'Active' : 'Inactive'}
    </Pill>
  );
};
